var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFavoriteFull = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0333 2.58301C12.525 2.58301 11.175 3.31634 10.3333 4.44134C9.49167 3.31634 8.14167 2.58301 6.63333 2.58301C4.075 2.58301 2 4.66634 2 7.24134C2 8.23301 2.15833 9.14967 2.43333 9.99967C3.75 14.1663 7.80833 16.658 9.81667 17.3413C10.1 17.4413 10.5667 17.4413 10.85 17.3413C12.8583 16.658 16.9167 14.1663 18.2333 9.99967C18.5083 9.14967 18.6667 8.23301 18.6667 7.24134C18.6667 4.66634 16.5917 2.58301 14.0333 2.58301Z",
    fill: "#FF2727"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFavoriteFull, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/favorite-full.793b6f8f.svg";
export { ForwardRef as ReactComponent };